import React from 'react';
import { encodeCode128B } from './code128';

const QUIET_ZONE = 10;

/** Genera el SVG (como string) para poder renderizarlo, imprimirlo o descargarlo. */
export const code128Svg = (text: string, moduleWidth = 2, height = 80): string => {
  const widths = encodeCode128B(text);
  const total = widths.reduce((a, b) => a + b, 0);
  const width = (total + QUIET_ZONE * 2) * moduleWidth;
  let x = QUIET_ZONE * moduleWidth;
  let bars = '';
  widths.forEach((w, i) => {
    const w2 = w * moduleWidth;
    if (i % 2 === 0) bars += `<rect x="${x}" y="0" width="${w2}" height="${height}" fill="#000"/>`;
    x += w2;
  });
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}"><rect width="${width}" height="${height}" fill="#fff"/>${bars}</svg>`;
};

export const Code128Barcode = ({ value }: { value: string }) => (
  <div
    style={{ background: '#fff', display: 'inline-block', maxWidth: '100%', overflow: 'hidden' }}
    dangerouslySetInnerHTML={{ __html: code128Svg(value) }}
  />
);
